module.exports = __webpack_public_path__ + "static/media/videToErr.6a647030.jpg";